<footer class="footer bg-dark text-light">
  <div class="container">
    <div class="row py-5">
      <!-- Brand Section -->
      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
        <h3 class="gradient-text mb-3">Koomzo</h3>
        <p class="text-muted mb-4">
          {{ 'footer.description' | translate }}
        </p>
        <div class="social-links">
          <a *ngFor="let social of socialLinks" 
             [href]="social.url" 
             [attr.aria-label]="social.label"
             class="social-link me-3"
             target="_blank"
             rel="noopener noreferrer">
            <i class="bi bi-{{ social.icon }}"></i>
          </a>
        </div>
      </div>
      
      <!-- Products Links -->
      <div class="col-lg-2 col-md-6 col-6 mb-4 mb-lg-0">
        <h5 class="mb-3">{{ 'footer.product' | translate }}</h5>
        <ul class="list-unstyled">
          <li *ngFor="let link of productLinks" class="mb-2">
            <a [routerLink]="link.route" class="text-muted footer-link">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
      
      <!-- Company Links -->
      <div class="col-lg-2 col-md-6 col-6 mb-4 mb-lg-0">
        <h5 class="mb-3">{{ 'footer.company' | translate }}</h5>
        <ul class="list-unstyled">
          <li *ngFor="let link of companyLinks" class="mb-2">
            <a [routerLink]="link.route" class="text-muted footer-link">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
      
      <!-- Legal Links -->
      <div class="col-lg-2 col-md-6 col-6 mb-4 mb-lg-0">
        <h5 class="mb-3">{{ 'footer.legal' | translate }}</h5>
        <ul class="list-unstyled">
          <li *ngFor="let link of legalLinks" class="mb-2">
            <a [routerLink]="link.route" class="text-muted footer-link">
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
      
      <!-- Newsletter -->
      <div class="col-lg-2 col-md-6 col-12">
        <h5 class="mb-3">{{ 'footer.newsletter.title' | translate }}</h5>
        <p class="text-muted small mb-3">
          {{ 'footer.newsletter.subtitle' | translate }}
        </p>
        <form class="newsletter-form">
          <input 
            type="email" 
            class="form-control mb-2" 
            [placeholder]="'footer.newsletter.emailPlaceholder' | translate"
            aria-label="Email for newsletter">
          <button type="submit" class="btn btn-primary btn-sm w-100">
            {{ 'common.subscribe' | translate }}
          </button>
        </form>
      </div>
    </div>
    
    <!-- Bottom Bar -->
    <div class="row py-4 border-top border-secondary">
      <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
        <p class="text-muted small mb-0">
          &copy; {{ currentYear }} Koomzo. {{ 'common.allRightsReserved' | translate }}.
        </p>
      </div>
      <div class="col-md-6 text-center text-md-end">
        <p class="text-muted small mb-0">
          {{ 'common.madeWith' | translate }}
        </p>
      </div>
    </div>
  </div>
</footer>

